<div class="terms-approvals-panel full-height layout-column">

  <div class="terms-approvals-header layout-column gap-10">
    <div class="layout-row layout-align-space-between-center">
      <div class="layout-row layout-align-start-center gap-10">
        <span class="br-subtitle-1">{{ 'Approved' | translate }}</span>
        @if (summary) {
          <span class="br-caption-2 gray-102">{{ summary.approvedCount }} / {{ summary.totalCount }}</span>
        }
      </div>
      <bringoz-button type="tertiary" size="fit" (onClick)="onClose.emit()">
        <bringoz-icon iconName="close" [classSize]="'md'"></bringoz-icon>
      </bringoz-button>
    </div>

    <div class="layout-row gap-10">
      <bringoz-button size="sm" theme="success"
                      [type]="filter === approvalStatuses.Approved ? undefined : 'outline'"
                      [isDisabled]="isLoading"
                      (onClick)="onToggleFilter(approvalStatuses.Approved)">
        <div class="layout-row layout-align-center-center gap-5">
          <bringoz-icon iconName="check" [classSize]="'sm'"></bringoz-icon>
          <span>{{ 'Approved' | translate }}</span>
        </div>
      </bringoz-button>
      <bringoz-button size="sm" theme="secondary"
                      [type]="filter === approvalStatuses.Pending ? undefined : 'outline'"
                      [isDisabled]="isLoading"
                      (onClick)="onToggleFilter(approvalStatuses.Pending)">
        <span>{{ 'Pending' | translate }}</span>
      </bringoz-button>
    </div>
  </div>

  <!-- First page of the selected list (panel open or filter switch): spinner instead of an empty table. -->
  @if (isLoading && !agents.length) {
    <div class="flex layout-row layout-align-center-center">
      <bz-spinner size="lg" [label]="'Loading' | translate"></bz-spinner>
    </div>
  } @else {
    <bz-table class="flex"
              [uniqueId]="tableUniqueId"
              [defaultWidths]="defaultWidths"
              [resizable]="false"
              [items]="agents"
              [isLoading]="isLoading"
              (fetchNext)="onFetchNext()">

      <ng-template bzTableRow let-agent>
        <div class="tr">
          <div class="td col-name text-ellipsis layout-row layout-align-start-center">
            <app-agent-link [agentId]="agent.id"
                            [agentName]="agent.user | userName">
            </app-agent-link>
          </div>
          <!-- The list is fetched per status, so every row of the Approved list is approved. -->
          <div class="td col-status layout-row layout-align-center-center">
            @if (filter === approvalStatuses.Approved) {
              <bringoz-icon class="terms-approved-icon" iconName="check-circle" [classSize]="'md'"
                            [tooltip]="'Approved' | translate"></bringoz-icon>
            }
          </div>
          <div class="td col-approved-at text-ellipsis layout-row layout-align-start-center">
            @if (filter === approvalStatuses.Approved) {
              {{ agent.termsVersionApprovalDetailsReference | bringozFullDate: 'approvedAt' : '-' }}
            }
          </div>
        </div>
      </ng-template>

      <app-empty-state bzTableEmptyState
                       src="assets/images/empty_state/empty_state_location_box.svg"
                       text="No agents found">
      </app-empty-state>

    </bz-table>
  }

  <!-- Next page while scrolling: how many of the list's agents are loaded so far. -->
  @if (isLoading && agents.length) {
    <div class="terms-approvals-progress">
      <bz-progress tone="secondary" [value]="agents.length" [max]="listSize"
                   [ariaLabel]="'Loading' | translate"></bz-progress>
    </div>
  }

</div>
